"use client";

import React from "react";

const classNames = (...classes: Array<string | false | null | undefined>) =>
  classes.filter(Boolean).join(" ");

export interface ProductRecommendationsProps {
  items: unknown[];
  renderItem: (item: unknown, index: number) => React.ReactNode;
  title?: string;
  loading?: boolean;
  error?: boolean;
  loadingMessage?: string;
  errorMessage?: string;
  className?: string;
  gridClassName?: string;
}

const ProductRecommendations: React.FC<ProductRecommendationsProps> = ({
  items,
  renderItem,
  title = "Рекомендуем также",
  loading = false,
  error = false,
  loadingMessage = "Загружаем подборку…",
  errorMessage = "Не удалось загрузить рекомендации",
  className = "",
  gridClassName = "mt-4 grid grid-cols-2 gap-3 md:grid-cols-4 lg:grid-cols-5",
}) => {
  const hasContent = items.length > 0;
  const shouldRenderSection = loading || hasContent || error;

  if (!shouldRenderSection) {
    return null;
  }

  return (
    <section className={classNames("mt-12", className)}>
      <div className="flex items-center justify-between gap-3">
        <h2 className="text-xl font-semibold text-gray-900">{title}</h2>
      </div>

      {loading && !hasContent ? (
        <div className="mt-4 text-sm text-default-500">{loadingMessage}</div>
      ) : null}

      {hasContent ? (
        <div className={gridClassName}>
          {items.map((item, index) => {
            const element = renderItem(item, index);
            if (React.isValidElement(element)) {
              return React.cloneElement(element, {
                key:
                  element.key ??
                  (item && typeof item === "object" && "code" in (item as any)
                    ? (item as any).code
                    : (item as any)?.id ?? `recommended-${index}`),
              });
            }
            return (
              <React.Fragment key={`recommended-${index}`}>
                {element}
              </React.Fragment>
            );
          })}
        </div>
      ) : null}

      {error && !loading && !hasContent ? (
        <div className="mt-4 text-sm text-red-500">{errorMessage}</div>
      ) : null}
    </section>
  );
};

export default ProductRecommendations;
